module.exports = __webpack_public_path__ + "assets/img/470171d8668ce2dc7b88fc62921a0cc6.svg";